export const updateObject=(oldObject, updatedValues)=>{
    
    return {
        
        ...oldObject,
        ...updatedValues
    }
}


// WEBPACK FOOTER //
// ./src/shared/utility.js